import D from './Display';

export { D };



// WEBPACK FOOTER //
// ./src/baseComponents/directives/Display/index.js